<template>
    <div>
        <div class="row">
            <div class="col-lg-12 col-xl-6">
                <div class="wrap-table-assign">
                    <b-table striped hover :fields="fieldsTableDataAssign" :items="listDataAssign">
                        <!-- <template #head(stt)="data">
                            <span class="col-table">{{ data.label }}</span>
                        </template> -->

                        <template #head(name)="data">
                            <div class="col-table text-center">{{ data.label }}</div>
                        </template>
                        <template #head(completeRate)="data">
                            <div class="col-table text-center">{{ data.label }}</div>
                        </template>
                        <template #head(duration)="data">
                            <div class="col-table text-center">{{ data.label }}</div>
                        </template>

                        <template #cell(completeRate)="row">
                            <div class="text-center">{{ formatCompleteRate(row.item.completeRate) }}%</div>
                        </template>
                        <template #cell(name)="row">
                            <div @click="handleGetListUserAssign(row)" class="mr-1 field-name text-center">
                                {{ row.item.name }}
                            </div>
                        </template>
                        <template #cell(duration)="row">
                            <div class="position-rel">
                                <div class="col-table text-center">{{ moment(row.item.duration).format('DD/MM/YYYY') }}
                                    <img @click="handleEditDuration(row)" class="icon-edit"
                                        src="@/assets/img/edit.png" />
                                </div>
                                <DropdownEditDuration v-if="itemCurrentSelectedId == row.item.id"
                                    @handleDone="handleDoneUpdateDuration" @hideDropdown="hideDropdownEditDuration"
                                    type="ELECTRONIC_LECTURE_WAREHOUSE" :item="row.item" />
                            </div>
                        </template>
                        <template #cell(action)="row">
                            <span @click="handleRecoveryAssign(row)" class="btn-recovery">
                                Thu hồi
                            </span>
                        </template>
                    </b-table>

                </div>
                <div class="margin-top-10">
                    <div class="display-flex-center">
                        <a href="javascript:;"
                            class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add"
                            @click="handleAssignLesson">
                            <img class="icon-plus" src="@/assets/img/plus.png" />
                            <img class="icon-plus" src="@/assets/img/plus-hover.png" />
                            Thêm lớp được giao
                        </a>
                    </div>
                </div>

            </div>
            <div class="col-lg-12 col-xl-6">
                <div class="py-2" v-if="itemCurrentSelected">
                    <h6>
                        <strong>{{ itemCurrentSelected.name }}</strong>
                    </h6>
                </div>
                <div class="wrap-left display-flex">
                    <div class="item item__key input-custom-icon">
                        <input type="text" name="keyword"
                            class="color_bg_gray_light border-0 border-rd-20 form-h30 primary-color-txt font-sanpro-light full-width"
                            placeholder="Tìm kiếm học sinh theo tên" v-model.lazy="keyword" v-debounce="300" />
                        <!-- <input @input="handleSearchUser" v-model="keyword" id="ListClassSchoolDelivered" type="text" placeholder="Tìm kiếm học sinh theo tên"
                            class="primary-color-txt color_bg_gray_light border-rd-20 font-size-15 form-h30 border-0 full-width search-user">
                        <i class="icon-search font-size-16 primary-color"></i> -->
                    </div>
                </div>
                <div class="wrap-table-assign">
                    <b-table ref="tableUserGroup" striped hover :fields="fieldsTableUserAssign"
                        :items="listDataUserAssign">
                        <template #head(stt)="data">
                            <div class="col-table text-center">{{ data.label }}</div>
                        </template>
                        <template #head(name)="data">
                            <div class="col-table text-center">{{ data.label }}</div>
                        </template>
                        <template #head(completeRate)="data">
                            <div class="col-table text-center">{{ data.label }}</div>
                        </template>
                        <template #head(completeDate)="data">
                            <div class="col-table text-center">{{ data.label }}</div>
                        </template>
                        <template #cell(stt)="row">
                            <div class="text-center">{{ row.item.stt }}</div>
                        </template>
                        <template #cell(name)="row">
                            <div class="text-center">{{ row.item.name }}</div>
                        </template>
                        <template #cell(completeRate)="row">
                            <div class="text-center">{{ formatCompleteRate(row.item.completeRate) }}%</div>
                        </template>
                        <template #cell(completeDate)="row">
                            <div class="text-center">{{ row.item.completeRate >= 100 ?
                                moment(row.item.completeDate).format('DD/MM/YYYY - HH:mm') : '' }}</div>
                        </template>
                    </b-table>
                </div>

            </div>
        </div>

        <ModalAssignLesson v-if="isShowAssignLesson" @closeModal="closeModalAssign" :type="ELECTRONIC_LECTURE_WAREHOUSE"
            :item="dataElectronicLecture" @handleAssignSuccess="handleAssignSuccess" :isAddMultiClass="true" />
        <ModalRecoveryAssign :type="ELECTRONIC_LECTURE_WAREHOUSE" v-if="isOpenModalRecoveryAssign"
            :dataLesson="dataElectronicLecture" :itemCurrentSelected="itemCurrentSelected"
            @closeModal="closeModalRecovery" @handelRecoveryDone="handelRecoveryDone" />
        <!-- <ModalEditDuration @handleDone="handleDoneUpdateDuration" @closeModal="closeModalEditDuration" v-if="isOpenModalEditDuration" :type="ELECTRONIC_LECTURE_WAREHOUSE" :item="itemSelected" /> -->
    </div>

</template>

<script>
import moment from "moment";
import { getListClassSchoolGroupAssignLesson, getListUserAssingLessonByGroupId, getListUserAssingLessonByClassSchoolId } from './../../../_api/LessonClassSchoolServices'
import ModalAssignLesson from './../ModalAssignLesson'
import { getDetail } from './../../../_api/LessonClassSchoolServices'
import ModalRecoveryAssign from './ModalRecoveryAssign'
import { PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN } from './../../../constants/constants_enum'
import ModalEditDuration from './ModalEditDuration'
import DropdownEditDuration from './DropdownEditDuration'
import debounce from "@/directives/debounce";
export default {
    directives: { debounce },
    components: {
        ModalAssignLesson,
        ModalRecoveryAssign,
        ModalEditDuration,
        DropdownEditDuration
    },
    data() {
        return {
            isOpenModalEditDuration: false,
            itemSelected: null,
            PLANING_LESSON_WAREHOUSE, PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE, ELECTRONIC_LECTURE_ASSIGN,
            fieldsTableDataAssign: [{ key: 'name', label: 'Tên lớp/nhóm' }, { key: 'completeRate', label: 'Tỷ lệ hoàn thành' }, { key: 'duration', label: 'Thời hạn hoàn thành' }, { key: 'action', label: '', thClass: 'w-70px', tdClass: 'w-70px' }],

            fieldsTableUserAssign: [{ key: 'stt', label: 'STT' }, { key: 'name', label: 'Họ tên học sinh' }, { key: 'completeRate', label: 'Tiến độ hoàn thành' }, { key: 'completeDate', label: 'Thời gian hoàn thành' }],

            listDataAssign: [],
            paramQueryData: {
                id: 0,
                type: ELECTRONIC_LECTURE_WAREHOUSE,
            },
            listDataUserAssign: [],
            keyword: '',
            itemCurrentSelected: null,
            dataElectronicLecture: {
                id: 0,
                name: '',
                bookTypeId: '',
                classId: '',
                subjectId: '',
                numberLesson: '',
                description: '',
                isPublic: false,
                type: ELECTRONIC_LECTURE_WAREHOUSE
            },
            lessonClassSchoolId: 0,
            isShowAssignLesson: false,
            isOpenModalRecoveryAssign: false,
            itemCurrentSelectedId: 0
        }
    },
    watch: {
        'keyword': 'getListUserAssign'
    },
    mounted() {
        this.paramQueryData.id = this.lessonClassSchoolId = this.$route.query.id
        this.getListClassGroupAssign()
        this.getDetailLessonClassSchool()
    },
    methods: {
        moment,
        handleSearchUser() {
            console.log('search')
        },
        closeModalAssign() {
            this.isShowAssignLesson = false
        },
        formatNumber(value) {
            if (typeof value !== 'number') {
                return value;
            }
            return value.toFixed(0);
        },
        formatCompleteRate(value){
            if (typeof value !== 'number') {
                return value;
            }
            return Number(value.toFixed(2));
        },
        handleDoneUpdateDuration() {
            this.getListClassGroupAssign()
            this.closeModalEditDuration()
            this.hideDropdownEditDuration()
        },
        closeModalEditDuration() {
            this.isOpenModalEditDuration = false
        },
        handleEditDuration(row) {
            this.itemSelected = row.item
            this.isOpenModalEditDuration = true
            this.itemCurrentSelectedId = row.item.id
        },
        handelRecoveryDone() {
            this.isShowAssignLesson = false
            this.getListClassGroupAssign()
            this.closeModalRecovery()
        },
        closeModalRecovery() {
            this.isOpenModalRecoveryAssign = false
        },
        handleAssignSuccess() {
            this.isShowAssignLesson = false
            this.getListClassGroupAssign()
        },
        getDetailLessonClassSchool() {
            let self = this
            getDetail(this.lessonClassSchoolId).then(res => {
                if (res && res.data && !res.errors) {
                    self.dataElectronicLecture = {
                        id: res.data.id,
                        name: res.data.name,
                        bookTypeId: res.data.bookTypeId,
                        classId: res.data.classId,
                        subjectId: res.data.subjectId,
                        numberLesson: res.data.numberLesson,
                        description: res.data.description,
                        isPublic: res.data.isPublic,
                        type: res.data.type,
                    }
                }
            })
        },
        handleGetListUserAssign(row) {

            this.itemCurrentSelected = row.item
            this.getListUserAssign()
        },
        handleAssignLesson() {
            this.isShowAssignLesson = !this.isShowAssignLesson
        },

        handleRecoveryAssign(row) {
            this.itemCurrentSelected = row.item
            this.isOpenModalRecoveryAssign = true
        },
        getListUserAssign() {
            console.log('123')
            if (this.itemCurrentSelected.groupId > 0) {
                this.getListUserAssignByGroupId()
            }
            else if (this.itemCurrentSelected.classSchoolId > 0) {
                this.getListUserAssignByClassSchoolId()
            }
        },
        getListUserAssignByGroupId() {
            this.listDataUserAssign = []
            getListUserAssingLessonByGroupId({ groupId: this.itemCurrentSelected.groupId, keyword: this.groupId, type: this.itemCurrentSelected.type, id: this.lessonClassSchoolId, status: 1 }).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listDataUserAssign.push({ 'userId': item.userId, 'stt': i + 1, 'name': item.userName, 'completeRate': item.completeRate, 'completeDate': item.completeDate })
                    }
                }
            })
        },
        getListUserAssignByClassSchoolId() {
            this.listDataUserAssign = []
            getListUserAssingLessonByClassSchoolId({ classSchoolId: this.itemCurrentSelected.classSchoolId, keyword: this.keyword, type: this.itemCurrentSelected.type, id: this.lessonClassSchoolId, status: 1 }).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listDataUserAssign.push({ 'id': item.id, 'userId': item.userId, 'stt': i + 1, 'name': item.userName, 'completeRate': item.completeRate, 'type': item.type, 'completeDate': item.completeDate })
                    }
                }
            })
        },
        getListClassGroupAssign() {
            this.listDataAssign = []
            getListClassSchoolGroupAssignLesson(this.paramQueryData).then(res => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listDataAssign.push({ 'id': item.id, 'groupId': item.groupId, 'classSchoolId': item.classSchoolId, 'stt': i + 1, 'name': item.groupId > 0 ? item.groupName : item.classSchoolName, 'completeRate': item.completeRate, 'duration': item.duration, 'type': item.type })
                        // thêm
                        if (i == 0) {
                            this.itemCurrentSelected = this.listDataAssign[0]
                            this.getListUserAssign()
                        }
                    }
                }
            })
        },
        hideDropdownEditDuration() {
            this.itemCurrentSelectedId = 0
        }
    }
}
</script>
<style lang="scss" scoped>
.margin-top-10{
    margin-top: 10px;
}
.btn-recovery {
    color: red;
    cursor: pointer;
}

.wrap-table-assign tbody {
    /* display: block; */
    /* height: 20rem; */
    overflow: auto;
}

.wrap-table-assign thead th,
.wrap-table-assign tbody td {
    text-align: center;
    padding: 0.5rem;
}

.wrap-table-assign thead th {
    font-weight: bold !important;
    color: #212529 !important;
}

thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    /* even columns width , fix width of table too*/
}

thead,
tbody {
    width: calc(100% - 1em)
        /* scrollbar is average 1em/16px width, remove it from thead width */
}

.custom-text-dropdown {
    color: black;
    background: transparent;
    outline: none;
    text-decoration: none;
}

.custom-text-dropdown:hover {
    color: black;
    background: transparent;
    outline: none;
    text-decoration: none;
}

.w-70px {
    width: 70px;
}

.search-user {
    margin-right: 30px !important;
}

.icon-edit {
    width: 15px;
    cursor: pointer;
}

.wrap-assign {
    border: 1px solid #c1c1c1;
    padding: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
    border-radius: 15px;
    background: #efeeee;
}

.wrap-table-assign {
    font-size: 13px !important;
    max-height: 30rem;
    overflow: auto;

    .field-name {
        cursor: pointer;
        color: #0f3dba;
    }

    .field-name:hover {
        cursor: pointer;
    }
}


.icon-plus {
    width: 20px;
    top: 0px !important;
    display: inline-block;
}

.btn-add-class-assigned {
    position: absolute;
    bottom: 1rem;
}
</style>